import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import NullStateDiv from '@components/NullStateDiv';
import ProfileBubble from '@components/ProfileBubble';
import {
  HorizontalFlex,
  VerticalFlex,
} from '@components/RecordCard/RecordCard.style';

import { useCuration } from '@hooks/useCuration';
import { useSession } from '@hooks/useSession';

import type { Profile } from '@models/session';

import { formatName } from '@utils/format';

import { Container, DropdownOption, NameDiv, Title } from './PatientList.style';

const messages = defineMessages({
  viewAs: {
    id: 'patientSelectionList.viewAs',
    defaultMessage: 'Select a patient to view records for',
  },
  noPatients: {
    id: 'patientSelectionList.noPatients',
    defaultMessage:
      'Patients you have access to will appear here in a list once they have granted you access.',
  },
});

export default function PatientList() {
  const { formatMessage } = useIntl();
  const {
    state: { allProfiles, loggedInProfile },
  } = useSession();
  const { viewAsPatient } = useCuration();
  const [user_id] = [loggedInProfile?.user_id];

  const changeUser = async (user: Profile) => {
    await viewAsPatient(user.user_id);
  };

  return (
    <Container>
      <HorizontalFlex>
        <VerticalFlex alignItems="center">
          <Title>{formatMessage(messages.viewAs)}</Title>
        </VerticalFlex>
      </HorizontalFlex>

      {allProfiles.length ? (
        allProfiles
          .filter((profile) => user_id !== profile.user_id)
          .map((user, index) => (
            <DropdownOption
              key={`dropdown-option-${index}`}
              // eslint-disable-next-line @typescript-eslint/no-misused-promises
              onClick={async () => changeUser(user)}
            >
              <ProfileBubble
                fallback="circle-user"
                s3Key={user.profile_picture}
                size={35}
              />
              <NameDiv>{formatName(user.first_name, user.last_name)}</NameDiv>
            </DropdownOption>
          ))
      ) : (
        <NullStateDiv>{formatMessage(messages.noPatients)}</NullStateDiv>
      )}
    </Container>
  );
}
